import { RedoSideNavigation } from "@redotech/redo-web/arbiter-components/navigation/redo-side-navigation";
import { filterTruthy } from "@redotech/util/array";
import { memo, useContext, useMemo } from "react";
import { SupportHelpContext } from "../../support-help-context";
import { useConversionNavigation } from "./conversion/conversion-navigation";
import { useCustomersNavigation } from "./customers/customers-navigation";
import { useHomeNavigation } from "./home/home-navigation";
import { useInventoryNavigation } from "./inventory/inventory-navigation";
import { useMarketingNavigation } from "./marketing/marketing-navigation";
import { useOrdersNavigation } from "./orders/orders-navigation";
import { useSettingsItems } from "./settings";
import { useSupportNavigation } from "./support/support-navigation";

export const MerchantAppSideNav = memo(function MerchantAppSideNav({
  enterSettingsUrl,
  exitSettingsUrl,
  settingsRoot,
  hideNav,
}: {
  enterSettingsUrl: string;
  exitSettingsUrl: string;
  settingsRoot: string;
  hideNav: boolean;
}) {
  const { onHelpClick } = useContext(SupportHelpContext);

  const homeEntry = useHomeNavigation();
  const conversionEntry = useConversionNavigation();
  const marketing = useMarketingNavigation();
  const orders = useOrdersNavigation();
  const inventory = useInventoryNavigation();
  const support = useSupportNavigation();
  const customers = useCustomersNavigation();

  const allPageEntries = useMemo(() => {
    return filterTruthy([
      homeEntry,
      conversionEntry,
      marketing,
      orders,
      inventory,
      support,
      customers,
    ]);
  }, [
    homeEntry,
    conversionEntry,
    marketing,
    orders,
    inventory,
    support,
    customers,
  ]);

  const settingsItems = useSettingsItems();

  return (
    <RedoSideNavigation
      enterSettingsUrl={enterSettingsUrl}
      exitSettingsUrl={exitSettingsUrl}
      isHidden={hideNav}
      pageEntries={allPageEntries}
      settingSections={settingsItems}
      settingsRoot={settingsRoot}
      toggleHelp={() => {
        onHelpClick?.();
      }}
    />
  );
});
